import type { ReactNode } from "react";

export const VEHICLE_RESTRICTION_BANNER = {
    RANGE_NOT_ALLOWED: "homepage-v2/post-form-banner/range-not-allowed.png",
    VEHICLE_NOT_ALLOWED: "homepage-v2/post-form-banner/vehicle-not-allowed.png"
} as const;

export type VehicleRestrictionKind =
    | "capacity_activate"
    | "capacity_reactivate"
    | "three_wheeler_lorry"
    | "three_wheeler_load_repost"
    | "unsupported_category";

export interface VehicleRestrictionPopupConfig {
    kind: VehicleRestrictionKind;
    bannerSrc: string;
    title: string;
    description: ReactNode;
    cancelLabel: string;
    primaryLabel: string;
}
